import {GET_OBJECT_SUCCESS} from "../../../../apps/KpModule/actions/api";
import {changeFieldProperty, setFieldEdition, setFieldEndDate} from "../../../../apps/KpModule/actions";

const _ = require('lodash')
const moment = require('moment')
const { setDataList } = require('../../../../apps/KpModule/actions')

export const module_ = {
    object: 'Batch',
    name: 'Payment',
    tKey: 'mTitle_batchPayment',
    objectIdentifier: 'reference',
    newable: false,
    removable: false,
    category: {
        path: 'bank',
        icon: 'bank'
    },
    viewMap: {
        dt: [
            'reference',
            {path: 'process', translate: true},
            {path: 'amount', tKey: 'amount(€)_abbreviation', tooltip: true},
            {path: 'requestsReferences', initiallyNotVisible: true},
            {path: 'orderLinesLength', tKey: 'number'},
            {path: 'status', translate: true},
            {path: 'creationDate', tKey: 'dateAndTime'},
            {path: 'paymentDate', tKey: 'payment'},
            {path: 'xlsxFile', tKey: 'xlsx',  width: 70, flexShrink: 0, flexGrow: 0},
            {path: 'xmlFile', tKey: 'xml',  width: 70, flexShrink: 0, flexGrow: 0}
        ],
        form: {
            fields: [
                {path: 'reference', disabled: true},
                {path: 'process', required: true, editable: false},
                {
                    path: 'orderLines',
                    fieldPath: ['id', 'fullReference', 'amount', 'processType'],
                    display: 'fullReference',
                    filters: ['selectedOnly'],
                    subscriptions: {
                        onChange: (newValue, oldValue, { formInitialize, module, store }) => {
                            const amount = module.viewMap.form.fields.find(
                                field => field.path === 'amount'
                            )
                            const number = module.viewMap.form.fields.find(
                                field => field.path === 'orderLinesLength'
                            )

                            if (newValue) {
                                const total = newValue.reduce((acc, line) => acc + parseFloat(line.amount), 0)
                                amount.setValue(_.round(total, 2))
                                number.setValue(newValue.length)
                            }else{
                                amount.setValue(0)
                                number.setValue(0)
                            }
                        }
                    }
                },
                {path: 'amount', tKey: 'amount(€)_abbreviation', disabled: true},
                {path: 'orderLinesLength', tKey: 'number', disabled: true},
                {path: 'paymentDate', type: 'datePicker', required: true},
                {path: 'status', hidden: true},
                {path: "buttons", hidden: true}
            ],
            onOpen: ({module, store}) => {
                const paymentDate = module.viewMap.form.fields.find(
                    field => field.path === 'paymentDate'
                )

                store.dispatch(setFieldEndDate(paymentDate.id, moment().format('YYYY-MM-DD')))
            }
        }
    },
    actionSubscriptions: [
        {
            actionType: GET_OBJECT_SUCCESS,
            subscription: ({ store }) => {
                const state = store.getState()
                const orderLines = _.get(state, 'edit.object.data.orderLines')
                const status = _.get(state, 'edit.object.data.status')

                store.dispatch(setFieldEdition('e_orderLines', status !== 'paid'))
                store.dispatch(setFieldEdition('e_paymentDate', status !== 'paid'))
                if(orderLines) {
                    store.dispatch(
                        setDataList(
                            "m-R-payment.Batch_orderLines",
                            orderLines
                        )
                    )
                }
            }
        }
    ],
    filters: [
        'byExercise',
        {
            path: "controlStep",
            match: function(request) {
                return ['controlled', 'paid'].includes(request.status)
            }
        },
        {
            title: "Status",
            path: "status",
            tKey: "status",
            type: 'tags',
            translate: true,
            default: [
                {id: 'controlled'}
            ],
            object: "PaymentStatus",
            display: "name",
            client: true,
            query: function (context) {
                const statusArray = _.get(context, "data.status")

                return statusArray
                    ? {status: {$in: statusArray.map(o => o.id)}}
                    : {status: false}
            }
        },
    ]
}
